module.exports = __webpack_public_path__ + "img/medicalingActive.5e6b8464.png";